import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { EXPAND_ICON_COLOR, EXPAND_BACKGROUND_COLOR } from '../constants';

type AccessAccordionProps = {
  icon: string,
  title: string,
  details: React.ReactNode,
};

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0),
    padding: theme.spacing(2.5, 0),
    borderBottom: `solid thin ${EXPAND_BACKGROUND_COLOR}`,
    '&.MuiAccordion-root:before': {
      backgroundColor: 'transparent',
    },
  },
  expanded: {
    borderBottom: 'none',
  },
  summaryContent: {
    alignItems: 'center',
  },
  expandIcon: {
    color: EXPAND_ICON_COLOR,
  },
  icon: {
    width: 40,
    height: '100%',
    marginRight: theme.spacing(2),
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  detailsContainer: {
    backgroundColor: EXPAND_BACKGROUND_COLOR,
    padding: theme.spacing(4),
  },
}));

const AccessAccordion = ({ icon, title, details }: AccessAccordionProps) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);
  const handleChange = () => setExpanded(!expanded);
  return (
    <>
      <Accordion
        elevation={0}
        expanded={expanded}
        onChange={handleChange}
        classes={{ root: classes.root, expanded: classes.expanded }}
      >
        <AccordionSummary
          classes={{
            content: classes.summaryContent,
          }}
          expandIcon={
            expanded ? (
              <RemoveIcon className={classes.expandIcon} />
            ) : (
              <AddIcon className={classes.expandIcon} />
            )
          }
        >
          <img src={icon} alt="" className={classes.icon} />
          <Typography variant="h3" className={classes.title}>
            {title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.detailsContainer}>
          <div>{details}</div>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default AccessAccordion;
